import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as layoutActions from "../../../actions/layoutActions";
import * as nieuweSportclubModelsActions from "../../../actions/nieuweSportclubModelsActions";
import ScrollToFirstErrorComponent from "../../common/ScrollToFirstErrorComponent";
import redirector from "../../../util/redirector";
import { onDropFiles, onRemoveFile } from "../../../components/common/FilesHelperUtil";
import * as ajaxActions from "../../../actions/ajaxCounterActions";
import { throwException } from "../../../actions/exceptionActions";
import mergeDeep from "../../../util/mergeDeep.js";

import OrganisatiePageHelper from "./OrganisatiePageHelper";
import OrganisatieForm from "./OrganisatieForm";

class OrganisatiePage extends ScrollToFirstErrorComponent {
    constructor(props, context) {
        super(props, context, true);

        this.state = {
            model: {
                naam: null,
                afkorting: null,
                telefoon: null,
                gsm: null,
                email: null,
                website: null,
                extraGegevens: null,
                logo: null,
                documentatie: null
            },
            errors: {}
        };

        this.pageHelper = new OrganisatiePageHelper(this, redirector);
    }

    componentDidMount = () => {
        super.componentDidMount();
        this.pageHelper.init();
    };

    componentWillUnmount = () => {
        let model = mergeDeep({}, this.state.model);
        this.props.updateModel(model);
    };

    handleOnGoToNext = () => this.pageHelper.goToNext();
    handleOnChange = (event) => this.pageHelper.change(event);
    handleOnDropFiles = (propertyName, files) => this.handleOnChangeFile(onDropFiles(this.state.model[propertyName] && this.state.model[propertyName].content ? [this.state.model[propertyName]] : [], propertyName, files));
    handleOnRemoveFile = (propertyName, fileName) => this.handleOnChangeFile(onRemoveFile(this.state.model[propertyName] && this.state.model[propertyName].content ? [this.state.model[propertyName]] : [], propertyName, fileName));
    handleOnChangeFile = (event) => this.pageHelper.changeFile(event);

    render() {
        return (
            <Fragment>
                <OrganisatieForm
                    model={this.state.model}
                    goToNext={this.handleOnGoToNext}
                    onChange={this.handleOnChange}
                    errors={this.state.errors}
                    onChangeFile={this.handleOnChangeFile}
                    onDropFile={this.handleOnDropFiles}
                    onRemoveFile={this.handleOnRemoveFile}
                />
            </Fragment>
        );
    }
}

OrganisatiePage.propTypes = {
    loadLayout: PropTypes.func
};

function mapStateToProps(state, ownProps) {
    return {
        storeModel: state.nieuweSportclubModels.organisatie
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        loadLayout: bindActionCreators(layoutActions.loadNieuweSportclubOrganisatiePageLayout, dispatch),
		setTabSettings: bindActionCreators(layoutActions.setTabSettings, dispatch),
        updateModel: bindActionCreators(nieuweSportclubModelsActions.organisatieModelUpdate, dispatch),
        ajaxActions: bindActionCreators(ajaxActions, dispatch),
        throwException: bindActionCreators(throwException, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(OrganisatiePage);